export default __webpack_public_path__ + "static/media/ky.0930de5b.wav";